import apiClient from '../api';

const getCompanies = () => apiClient.get('/admin/companies');

export default { getCompanies };


